import React from "react";
import { Label } from "semantic-ui-react";
import { formatEventThemes } from "modules/helpers";

const EventThemesLabel = ({ themes, ...props }) => (
  <Label {...props} basic content={formatEventThemes(themes)} size="large" />
);

export default EventThemesLabel;
